import React, { useEffect, useState } from 'react'
import NumberFormat from 'react-number-format'
import errorAlert from '../../../assets/images/error-alert.svg'
import dayjs from 'dayjs'
import { WatDatePicker } from '../../../component/datePicker'
import { BANKS, PAYMENTMODE, targetBankCode } from '../../../constants'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducers } from '../../../redux/reducers'
import * as paymentDetailAction from '../../../redux/actions/paymentDetail.detail.action'
import { PayInBank } from '../../../component/entryForm/bankAccount'

interface CashPayInProps {
  documentId: number
  form: any
  setPaymentDetailFormValue: (form: any) => void
}

const Cheque: React.VFC<CashPayInProps> = ({ documentId, form, setPaymentDetailFormValue }) => {
  const accountData = useSelector((state: RootReducers) => state.bankAccountReducer)
  const dispatch = useDispatch()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [formData, setFormData] = useState(form)
  const [formErrors, setFormErrors] = useState<any>({
    paymentAmount: false,
    cheque_Date: false,
    cheque_Number: false,
    cheque_Bank: false,
    cheque_BankCode: false,
    cheque_Branch: false,
    bankCode: false,
    accountNo: false,
    payInDate: false,
    paymentTotalAmount: false
  })

  const bankOptions = BANKS.map((bank: { BANKCD: any; BANKNAME: any; BANKSHORTNAME: any }) => ({
    value: bank.BANKCD,
    label: `${bank.BANKSHORTNAME} - ${bank.BANKNAME}`,
    shortName: bank.BANKSHORTNAME,
    bankName: bank.BANKNAME
  }))

  const onChangeAmount = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value } = e?.target
    setFormData({
      ...formData,
      [name]: Number(value.replace(/,/g, ''))
    })
  }

  const onChangeChequeDate = (christDate: any, buddhistDate: any) => {
    setFormData({ ...formData, cheque_Date: christDate })
  }

  const onChangePayInDate = (christDate: any, buddhistDate: any) => {
    setFormData({ ...formData, payInDate: christDate })
  }

  const onChangeValue = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value } = e?.target
    setFormData({
      ...formData,
      [name]: value
    })
  }

  const onChangeChequeBank = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    setFormData({ ...formData, cheque_Bank: e?.bankName, cheque_BankCode: e?.value })
  }

  const validateAllValue = () => {
    const exceptionalFields = ['remarkMoneyType']
    let allErrors = formErrors
    let isError = false
    Object.keys(formData).forEach(key => {
      const value = formData[key]
      if (!exceptionalFields.includes(key) && formErrors[key] !== undefined) {
        allErrors = { ...allErrors, ...{ [key]: !value ? true : false } }
        if (!value) {
          isError = true
        }
      }
    })
    setFormErrors(allErrors)
    return isError
  }

  const onSubmit = () => {
    if (validateAllValue()) {
      return
    }
    setIsSubmitting(true)
    const updatedData = { ...form, ...formData }
    setPaymentDetailFormValue(updatedData)
    dispatch(paymentDetailAction.updatePaymentDetail(documentId, updatedData))
    setIsSubmitting(false)
  }
  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement> | any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const onChangePayInBank = (bankAccountModelView: any) => {
    const changedFieldName = bankAccountModelView?.target?.name
    const updatedValue = bankAccountModelView?.target?.value
    if (changedFieldName === targetBankCode) {
      setFormData({
        ...formData,
        ...{
          ['bankCode']: updatedValue,
          ['accountNo']: ''
        }
      })
    } else {
      setFormData({
        ...formData,
        ...{
          ['accountNo']: updatedValue,
          ['payInToBank']: bankAccountModelView?.payInToBank
        }
      })
    }
  }

  return (
    <div className="container-inf">
      <div className="form-content">
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">จำนวนเงิน</span>
            <NumberFormat
              allowNegative={false}
              thousandSeparator={true}
              prefix=""
              name="paymentAmount"
              className={`amount-input ${formErrors.paymentAmount && 'error-border-validate'}`}
              inputMode="decimal"
              decimalScale={2}
              autoComplete="off"
              onChange={onChangeAmount}
              disabled={true}
              value={formData?.paymentAmount}
              onKeyPress={handleEnterKey}
            />
            {formErrors.paymentAmount && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">จำนวนเงินตามหน้าเช็ค</span>
            <NumberFormat
              allowNegative={false}
              thousandSeparator={true}
              prefix=""
              name="paymentTotalAmount"
              className={`amount-input ${formErrors.paymentTotalAmount && 'error-border-validate'}`}
              inputMode="decimal"
              decimalScale={2}
              autoComplete="off"
              onChange={onChangeAmount}
              disabled={true}
              value={formData?.paymentTotalAmount}
              onKeyPress={handleEnterKey}
            />
            {formErrors.paymentTotalAmount && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <span className="amount-text">เช็คลงวันที่</span>
          <WatDatePicker
            className={`amount-input ${formErrors.cheque_Date && 'error-border-validate'}`}
            name="cheque_Date"
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={true}
            readOnly={false}
            yearBoundary={99}
            onChange={onChangeChequeDate}
            value={formData?.cheque_Date}
          />
          {formErrors.cheque_Date && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">เลขที่เช็ค</span>
            <input
              className={`amount-input ${formErrors.cheque_Number && 'error-border-validate'}`}
              type="text"
              name="cheque_Number"
              autoComplete="off"
              value={formData?.cheque_Number}
              onChange={onChangeValue}
              disabled={true}
              onKeyPress={handleEnterKey}
            />
            {formErrors.cheque_Number && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">ธนาคารเจ้าของเช็ค</span>
            <Select
              name="cheque_Bank"
              options={bankOptions}
              placeholder="ธนาคาร"
              isDisabled={true}
              onChange={onChangeChequeBank}
              value={bankOptions.find((obj: any) => obj.value === formData?.cheque_BankCode)}
            />
            {formErrors.cheque_Bank && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">สาขาธนาคารเจ้าของเช็ค</span>
            <input
              className={`amount-input ${formErrors.cheque_Branch && 'error-border-validate'}`}
              name="cheque_Branch"
              placeholder="สาขา"
              // disabled={true}
              onChange={onChangeValue}
              value={formData?.cheque_Branch}
              onKeyPress={handleEnterKey}
            />
            {formErrors.cheque_Branch && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <PayInBank
            paymentMode={PAYMENTMODE.CKC}
            branchCode={loginState.account?.agentInfo.branchCode as string}
            onSelect={bankAccountModelView => {
              onChangePayInBank(bankAccountModelView)
            }}
            defaultBankCode={formData.bankCode}
            defaultAccount={formData.accountNo}
            isRequireBank={formErrors?.bankCode}
            isRequireAccountNo={formErrors?.accountNo}
          />
        </div>

        <div className="required">
          <span className="amount-text">วันที่ฝาก</span>
          <WatDatePicker
            className={`amount-input ${formErrors.payInDate && 'error-border-validate'}`}
            name={formErrors.payInDate}
            onChange={(christDate: any, buddhistDate: any) => {
              onChangePayInDate(christDate, formErrors.payInDate)
            }}
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={false}
            readOnly={false}
            yearBoundary={99}
            inputStyle={formErrors.payInDate ? { borderColor: '#b30909' } : null}
            value={formData.payInDate}
          />
          {formErrors?.payInDate && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        <span className="amount-text">หมายเหตุ</span>
        <input
          className={`amount-input`}
          type="text"
          name="remarkMoneyType"
          autoComplete="off"
          value={formData?.remarkMoneyType}
          onChange={onChangeValue}
          onKeyPress={handleEnterKey}
        />
        <div className="button-container">
          <button
            className="cancel-button"
            onClick={() => {
              setPaymentDetailFormValue('')
            }}
          >
            ยกเลิก
          </button>
          <button className="confirm-paid-button" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'ตกลง'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Cheque
